import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useUserMetadata } from '../context/UserMetadataContext';
import './Profile.css';

const Profile = () => {
  const { user, isAuthenticated } = useAuth0();
  const { userMetadata, isLoading } = useUserMetadata();

  if (!isAuthenticated || !user) {
    return null;
  }

  if (isLoading) {
    return (
      <div className="profile-page">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  // Debug output
  console.log('Profile Component - User metadata:', userMetadata);

  return (
    <div className="profile-page">
      <h1>Profile</h1>
      <div className="profile-content">
        <div className="profile-section">
          <h2>Account Information</h2>
          <div className="profile-info">
            <div className="profile-header">
              <img src={user.picture} alt={user.name} className="profile-picture" />
              <div className="profile-details">
                <h3>{user.name}</h3>
                <p>{user.email}</p>
                <div className="metadata-field">
                  <span className="metadata-label">Company:</span>
                  <span className="metadata-value">{userMetadata?.company || 'Not specified'}</span>
                </div>
                <div className="metadata-field">
                  <span className="metadata-label">Role:</span>
                  <span className="metadata-value">{userMetadata?.role || 'Not specified'}</span>
                </div>
                <div className="metadata-field">
                  <span className="metadata-label">Industry:</span>
                  <span className="metadata-value">{userMetadata?.industry || 'Not specified'}</span>
                </div>
                {userMetadata?.registration_date && (
                  <div className="metadata-field">
                    <span className="metadata-label">Member since:</span>
                    <span className="metadata-value">
                      {new Date(userMetadata.registration_date).toLocaleDateString()}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="profile-section">
          <h2>Account Status</h2>
          <div className="status-info">
            <div className="status-item">
              <strong>Account Type:</strong>
              <span>{userMetadata?.account_type || 'Standard'}</span>
            </div>
            <div className="status-item">
              <strong>User ID:</strong>
              <span>{user.sub}</span>
            </div>
            <div className="status-item">
              <strong>Email Verified:</strong>
              <span>{user.email_verified ? 'Yes' : 'No'}</span>
            </div>
            <div className="status-item">
              <strong>Registration Status:</strong>
              <span>{userMetadata?.registration_completed ? 'Completed' : 'Pending'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
